import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const postcode = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return postcode.get("/shipping/postcodes?" + qstr);
  },
  getTimeslots(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return new Promise((resolve, reject) => {
      postcode
        .get("/shipping/timeslots?" + qstr)
        .then((res) => {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              res.data.data.map((el) => {
                if (el.info) {
                  el.info.date = fx.formatDate(
                    el.info.date,
                    this.$store.getters.timezone
                  );
                }
              });
            } else {
              if (res.data.data.data && res.data.data.data.length > 0) {
                res.data.data.data.map((el) => {
                  if (el.info) {
                    el.info.date = fx.formatDate(
                      el.info.date,
                      this.$store.getters.timezone
                    );
                  }
                });
              }
            }
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createTimeslot(inputs) {
    return postcode.post("/shipping/create-timeslot", {
      zipcode: inputs.zipcode,
      date_from: fx.formatServerDate(inputs.date_from),
      date_to: fx.formatServerDate(inputs.date_to),
      charge_amount: inputs.charge_amount,
      time_from: inputs.time_from,
      time_to: inputs.time_to,
    });
  },
  create(inputs) {
    return postcode.post("/shipping/postcodes", inputs);
  },
  delete(id) {
    return postcode.delete("/shipping/postcodes/" + id);
  },
  deleteTimeslot(id) {
    return postcode.delete("/shipping/timeslot/" + id);
  },
  updateTimeslot(id, inputs) {
    return postcode.put("/shipping/timeslot/" + id, {
      date: fx.formatServerDate(inputs.date),
      charge_amount: inputs.charge_amount,
      time_from: inputs.time_from,
      time_to: inputs.time_to,
    });
  },
};
